export class FetchCommandError extends Error {
	constructor(type, message, name = 'FetchCommandError') {
		super();
		this.name = name;
		this.type = type;
		this.message = typeof message === 'object' ? message : message?.toString().replace('Error: ', '');
		// keep String replacement, because nearly all ErrorHandling is checking for exact String (without "Error: " in front).
		// There might be one ErrorHandling that is broken now, but I can't remember. Some Handling has to deal with an Array, that failes if we try to make a String out of it
	}
}

export class PermissionFetchCommandError extends FetchCommandError {
	constructor(message) {
		super('permission', message, 'PermissionFetchCommandError');
	}
}

export class TechnicalFetchCommandError extends FetchCommandError {
	constructor(message) {
		super('technicalError', message, 'TechnicalFetchCommandError');
	}
}
